// extracted by mini-css-extract-plugin
export var conversationListItem = "_ys-2";
export var fullBleedList = "_ys-3";
export var messageText = "_ys-1";
export var previewText = "_ys-0";